export const AGE = [
    {label: '0-18', _id: '507f1f77bcf86cd799439010'},
    {label: '19-24', _id: '507f1f77bcf86cd799439011'},
    {label: '25-34', _id: '507f1f77bcf86cd799439012'},
    {label: '35-44', _id: '507f1f77bcf86cd799439013'},
    {label: '45-54', _id: '507f1f77bcf86cd799439014'},
    {label: '55-64', _id: '507f1f77bcf86cd799439015'},
    {label: '65-74', _id: '507f1f77bcf86cd799439016'},
    {label: '75+', _id: '507f1f77bcf86cd799439017'},
    {label: 'Prefer Not to Answer', _id: '507f1f77bcf86cd799439018'},
];
